export var ACTION;
(function (ACTION) {
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["OPEN_TCL"] = "OPEN_TCL";
    ACTION["OPEN_BAJAJ_FIN"] = "OPEN_BAJAJ_FIN";
    ACTION["OPEN_DSP_LINK"] = "OPEN_DSP_LINK";
    ACTION["OPEN_BAJAJ_LOAN_AGAINST_MUTUAL_FUNDS_LINK"] = "OPEN_BAJAJ_LOAN_AGAINST_MUTUAL_FUNDS_LINK";
})(ACTION || (ACTION = {}));
;
